import { getCoreDieAppearance } from './coreDieAppearance';
import { coreColorCss } from './coreAppearance';
import './CoreDie.css';

const CoreDieFallback = ({ phase, value = '?', travelling = false }) => {
  const skin = getCoreDieAppearance(phase);
  return (
    <div
      className={`coreboundCoreDieFallback ${travelling ? 'is-travelling' : ''}`}
      data-core-die-phase={skin.phase}
      style={{
        '--core-die-accent': coreColorCss(skin.accent),
        '--core-die-body': coreColorCss(skin.body),
        '--core-die-ink': skin.color,
      }}
      aria-hidden="true"
    >
      <span className="coreboundCoreDieFallbackAura" />
      <span className="coreboundCoreDieFallbackCube">
        <b>{value}</b>
      </span>
      <small>{skin.name}</small>
    </div>
  );
};

export default CoreDieFallback;
